<template>
  <div class="otstablenew">
    <div class="batchOperation" v-if="resetBatchOperBtn.length > 0">
      <ul>
        <li class="batchBtn" v-for="item in resetBatchOperBtn" :key="item.title" @click="item.click()" >
          <a href="javascript:;">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </a>
        </li>
      </ul>
    </div>
    
    <div style="font-size:18px;margin-bottom:20px;font-weight:600;text-align:center" v-if="descript">
      <span>{{descript}}</span>
    </div>

    <div style="margin-bottom:20px;font-weight:600;text-align:left;color: #FE5859;" v-if="messageDescript">
      <span v-html="messageDescript"></span>
    </div>

    <div style="font-size:18px;margin-bottom:20px;font-weight:600;" v-if="isExamReport">
      <span>正式考试</span>
    </div>

    <div class="ots-table">
      <el-table
        ref="el-table"
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        :header-cell-style="stageClass"
      >
        <!-- 多选框 -->
        <el-table-column 
          v-if="tableOption.multiple" 
          type="selection" 
          width="55" 
          :selectable="isDisabledMultiple"
        ></el-table-column>

        <!-- 表头 -->
        <template v-for="(item, index) in resetTableHeader" >
          <!-- 普通表格 -->
          <el-table-column 
            :key="index"
            v-if="!item.type"
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <el-tooltip 
                class="item" 
                effect="dark" 
                placement="top-start" 
                v-if="Is_MessagePush_CourseName && (item.prop == 'courseName' || item.prop == 'content')"
              >
                <p slot="content" v-html="getAll_courseName(item, scope)" style="line-height: 18px;">
                </p>
                <span
                  class="table-text" 
                  v-html="getTableText(item, scope)"
                  @click="getTableText(item, scope)"
                ></span>
              </el-tooltip>
                <span
                  v-else
                  class="table-text" 
                  v-html="getTableText(item, scope)" 
                  @click="getTableText(item, scope)" 
                ></span>
            </template>
          </el-table-column>

          <!-- 多级表头 -->
          <el-table-column
            :key="index"
            v-else-if="item.type == 'stage'"
            v-bind="setAttribute(item, index)"
          >
            <el-table-column
              v-for="(val, key) in item.headerList"
              :key="key"
              :label="val.title"
              v-bind="setAttribute(item, index)"
            >
              <template slot-scope="scope">
                <span
                  class="table-text"
                  v-html="getTableText(val, scope)"
                  :style="{ 'color': scope.row.examUnAssignPeoples > 0 ? val.color : '' }"
                ></span>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 圆形图片类型 -->
          <el-table-column 
            :key="index" 
            v-else-if="item.type === 'img'" 
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <div  class="table-img-container"  @click="showBigImg(scope.row[item.prop])">
                <div  class="big-img"  :style="{ display: 'none', top: scope.$index < 1 ? '0px' : '-72px' }">
                  <img :src="scope.row[item.prop]" alt="" v-if="scope.row[item.prop]" />
                </div>
                <img class="table-img" :src="scope.row[item.prop] ? scope.row[item.prop]: defaultImg" />
                <span></span>
              </div>
            </template>
          </el-table-column>

          <el-table-column 
            :key="index" 
            v-else-if="item.type === 'imageArray'" 
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <div class="table-imgarr-border" style="justify-content: space-around;">
                <div  class="table-img-container" v-for="(e, i) in scope.row[item.prop].split(',')" :key="i" >
                  <div  class="big-img"  :style="{ display: 'none', top: scope.$index < 1 ? '0px' : '-72px' }">
                    <img :src="e" alt="" v-if="e" @click="showBigImg(e)" />
                  </div>
                  <img class="table-img" :src="e ? e: defaultImg" @click="showBigImg(e)" />
                  <span></span>
                </div>
              </div>
            </template>
          </el-table-column>


          <!-- 文字分组 -->
          <el-table-column 
            :key="index" 
            v-else-if="item.type === 'textArray'" 
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <div  class="table-img-container" v-for="(e, i) in scope.row[item.prop].split('#')" :key="i" >

                <p>{{e}}</p>

                <!-- <div  class="big-img"  :style="{ display: 'none', top: scope.$index < 1 ? '0px' : '-72px' }">
                  <img :src="e" alt="" v-if="e" @click="showBigImg(e)" />
                </div>
                <img class="table-img" :src="e ? e: defaultImg" @click="showBigImg(e)" /> -->
                <span></span>
              </div>
            </template>
          </el-table-column>


          <!-- 方形图片类型 -->
          <el-table-column 
            :key="index" 
            v-else-if="item.type === 'imgBig'" 
            v-bind="setAttribute(item, index)" 
            class="label_imgarr" 
            width="110"
          >
            <template slot-scope="scope">
              <div class="table-imgarr-border">
                <div class="table-imgarr-container" @click="showBigImg(scope.row[item.prop])" >
                  <img class="table-imgarr" :src="scope.row[item.prop]" />
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 图片类型, 方形 - 数据为数组 -->
          <el-table-column
            :key="index"
            v-else-if="item.type === 'imgNormal'"
            v-bind="setAttribute(item, index)"
            class="label_imgarr"
            width="110"
          >
            <template slot-scope="scope">
              <div class="table-imgarr-border">
                <div class="table-imgarr-container" v-for="e in scope.row[item.prop]" :key="e.id">
                  <img
                    class="table-imgarr" 
                    :src="e.photo"
                    @click="showBigImg(e.photo)"
                    v-if="isVideoMp4.indexOf(e.photo.substr(e.photo.lastIndexOf('.') + 1)) == -1"
                  />
                  <video  @click="showBigVideo(e.photo)" v-else class="table-video">
                    <source :src="e.photo" >
                  </video>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 图片类型, 方形集合 -->
          <el-table-column
           :key="index"
            v-else-if="item.type === 'imgArr'"
            v-bind="setAttribute(item, index)"
            class="label_imgarr"
            :width="90 * (isVarAudit + 1) + 20"
          >
            <template slot-scope="scope">
              <div class="table-imgarr-border">
                <div class="table-imgarr-container" v-for="e in scope.row[item.prop]" :key="e.id">
                  <img class="table-imgarr" :src="e.photo" @click="showBigImg(e.photo)"/>
                </div>
                <div class="table-imgarr-container" v-if="scope.row[item.prop].length == 0">
                  <p> - </p>
                </div>
              </div>
            </template>
          </el-table-column>



          <el-table-column
            :key="index"
            v-else-if="item.type === 'switch'"
            v-bind="setAttribute(item, index)"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row[item.prop]"
                :active-value="1"
                :inactive-value="0"
                @change="item.switchChange(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-bind="setAttribute(item, index)"
            v-else-if="item.type === 'tag_Q'"
          >
            <template slot-scope="scope">
              <span :class="item.tagColor(scope)">{{ scope.row[item.prop] }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-bind="setAttribute(item, index)"
            v-else-if="item.type === 'tag_Z'"
          >
            <template slot-scope="scope">
              <span class="tagZ" :class="item.tagColor(scope)">
                <i></i>
                {{ getTableText(item, scope) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-bind="setAttribute(item, index)"
            v-else-if="item.type === 'state'"
          >
            <template slot-scope="scope">
              <span>
                <i class="iconfont f12" :class="stateClass[item.stateFlag(scope)]"></i>
                {{ scope.row[item.prop] }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-else-if="item.type === 'button'"
            v-bind="setAttribute(item, index)"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <el-button
                :type="'text'"
                :size="item.size || 'mini'"
                :disabled="item.disableFn ? item.disableFn(scope) : item.disabled"
                @click="item.click(scope.row)"
                v-html="getTableText(item, scope)"
              >
              </el-button>
            </template>
          </el-table-column>
          <!-- 有按钮 tooltip -->
          <el-table-column
            :key="index"
            v-else-if="item.type === 'buttonTip'"
            v-bind="setAttribute(item, index)"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row[item.prop]" placement="top" >
                <el-button
                :type="'text'"
                :size="item.size || 'mini'"
                :disabled="item.disableFn ? item.disableFn(scope) : item.disabled"
                @click="item.click(scope.row)">
                {{ scope.row[item.prop] }}
              </el-button>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            class="operate"
            v-else-if="item.type === 'buttons'"
            v-bind="setAttribute(item, index)"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-for="(itemBtn, index) in item.btnList"
                :key="index"
                :type="itemBtn.type || 'text'"
                :size="itemBtn.size || 'mini'"
                :disabled="itemBtn.formatter ? itemBtn.formatter(scope) : itemBtn.disabled"
                @click="itemBtn.click(scope.row, itemBtn)"
              >
                {{ typeof itemBtn.title === "function" ? itemBtn.title(scope) : itemBtn.title }}
              </el-button>
            </template>
          </el-table-column>


          <el-table-column
            :key="index"
            class="operate"
            v-else-if="item.type === 'buttons_set'"
            v-bind="setAttribute(item, index)"
            fixed="right"
          >
            <template slot="header">
              <el-tooltip class="item" effect="dark" :content="item.tableSettings.content" placement="top" v-show="item.disabled">
                <i class="icon" :class="item.tableSettings.icon" @click="item.tableSettings.click" ></i>
              </el-tooltip>
              <i class="icon" :class="item.tableSettings.icon" style="color: #CCC" v-show="!item.disabled"></i>
              <span>&nbsp;&nbsp;操作</span>
            </template> 
           
            <template slot-scope="scope">
              <el-button
                v-for="(itemBtn, index) in item.btnList"
                :key="index"
                :type="itemBtn.type || 'text'"
                :size="itemBtn.size || 'mini'"
                :disabled="itemBtn.formatter ? itemBtn.formatter(scope) : itemBtn.disabled"
                @click="itemBtn.click(scope.row, itemBtn)"
              >
                {{ typeof itemBtn.title === "function" ? itemBtn.title(scope) : itemBtn.title }}
              </el-button>
            </template>
          </el-table-column>

          <el-table-column 
            :key="index"
            v-else-if="item.type === 'textTooltip'"
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                placement="right-start"
                :disabled="item.disableFn ? item.disableFn(scope) : item.disabled"
              >
                <p slot="content" v-html="item.data(scope)"></p>
                <el-link
                    type="primary"
                    :underline="false"
                    class="table-text"
                    v-html="getTableText(item, scope)"
                    @click="getTableText(item, scope)"
                ></el-link>
              </el-tooltip>
            </template>
          </el-table-column>

        </template>
      </el-table>

      <!-- 图片类型弹窗 -->
      <el-dialog
        title="展示图片"
        :visible.sync="isShowBigImg"
        append-to-body
        width="960px"
        height="600px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        class="showBigImg"
      >
        <img :src="stataBigImg" alt="">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isShowBigImg = false">关闭展示图片</el-button>
        </span>
      </el-dialog>
      <!-- 视频弹窗 -->
      <el-dialog
        title="展示视频"
        :visible.sync="isShowBigVideo"
        append-to-body
        width="960px"
        height="600px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        class="showBigImg"
      >
        <video-player ref="videoPlayer" :options="playerOption" :playsinline="true" style="height: 420px;width: 320px;">
        </video-player>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isShowBigVideo = false">关闭展示视频</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
export default {
  name: "OtsTableNew",
  props: {
    messageDescript: {
      type: String,
      default: () => ""
    },
    descript: {
      type: String,
      default: () => ""
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableOption: {
      type: Object,
      default: () => ({}),
    },
    batchOperBtn: {
      type: Array,
      default: () => [],
    },
    isDisabledMultiple: {
      type: Function,
      default: () => true,
    },
  },
  data () {
    return {
      defaultImg: require('@/assets/img/userBg.png'),
      playerOption: {
        sources: [
          {
            type: "video/mp4",
            src: ""
          }
        ],
        fluid: true,
        controls: true,
      },
      isVideoMp4: ["mp4", "MP4"],
      isShowBigVideo: false,
      // 是否显示自定义图片大图弹窗
      isShowBigImg: false,
      // 存储大图的变量
      stataBigImg: '',
      // 存储大图的变量标题
      stataBigImgTitle: '',
      stateClass: {
        green: {'icon-tongguo': true, 'col_green': true},
        red: {'icon-weitongguo': true, 'col_red': true},
        orange: {'icon-daishenhe': true, 'col_orange': true}
      },
      // 机考人脸审核, 随机验证label长度
      inProcessPhotoLength: 0,
    }
  },

  computed: {

    isTooltip(){
      if (this.$route.name == 'messageDetailed' && item.prop == 'content') {
        return true;
      } else if(this.$route.name == 'messagePush' && item.prop == 'courseName') {
        return true;
      } else {
        return false;
      }
    },

    isExamReport(){
      return  this.$route.name == 'examReport';
    },

    /**************************************************
     * @this 针对机考人脸验证,配置对应label宽度
     **************************************************/
    isVarAudit(){
      if (this.$route.name == 'varAudit'){
        this.tableData.map( e => {
          if (this.inProcessPhotoLength < e.inProcessPhoto.length) {
            this.inProcessPhotoLength = e.inProcessPhoto.length;
          }
        })
        return this.inProcessPhotoLength;
      }
    },

    /**************************************************
     * @this 针对短信督导_表格_报考课程,展示全部课程名
     **************************************************/
    Is_MessagePush_CourseName(item) {
      return this.$route.name == 'messagePush' || this.$route.name == "messageDetailed";
    },

    resetTableHeader() {
      return this.tableHeader.filter((item) => !item.notShow)
    },
    resetBatchOperBtn() {
      return this.batchOperBtn.filter(item => !item.notShow)
    }
  },

  methods: {
    /**************************************************
     * @this "短信督导"：鼠标悬浮报考课程,提示的数据
     **************************************************/
    getAll_courseName(item, scope){
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop]
      if (text === "Invalid date") {
        return "-"
      } else {
        return text || text == "0" ? text : "-"
      }
    },

    /**************************************************
     * @this 针对"评阅自动分配",单独配置"已考考生"表头样式 
     *************************************************/
    stageClass({ row, column, rowIndex, columnIndex }){
      if (this.$route.name == 'autoAssign') {
        const stageColor = ['已考考生', '已分配', '已评阅', '未分配']
        const stageIndexs  = [0, 1, 2]
        if (stageColor.includes(column.label) && stageIndexs.includes(columnIndex) ) {
          return 'background-color: #EBF5FF'
        } else {
          return false
        }        
      } else {
        return false
      }
    },

    /**************************************************
     * @showBigImg 显示大图弹窗功能(配置大图显示数据)
     *************************************************/
    showBigImg(url){
      this.isShowBigImg = true
      this.stataBigImg = url
    },

    /**************************************************
     * @showBigVideo 视频弹窗功能(配置视频显示数据)
     *************************************************/
    showBigVideo(url){
      this.isShowBigVideo = true;
      this.playerOption.sources[0].src = url;
    },

    /**************************************************
     * @mouseenterImg 鼠标移入图片展示方形图片
     *************************************************/
    mouseenterImg(e, img) {
      let targetDom = e.target.previousSibling;
      let imgDom = new Image();
      imgDom.src = img;
      targetDom.appendChild(imgDom);
    },

    /**************************************************
     * @removeImg 鼠标移出功能，取消方形图片展示
     *************************************************/
    removeImg(e) {
      let targetDom = e.target.previousSibling;
      let img = targetDom.getElementsByTagName("img")[0];
      img.remove();
    },

    /**************************************************
     * @setAttribute 配置表格排版
     *************************************************/
    setAttribute(item, index) {
      // (1) 表格头居中页面路由名
      const centerView = ['autoAssign'];
      let routeName = this.$route.name;
      // (2) 数组最后一个路由下标
      let maxIndex = this.tableHeader.length - 1;
      // (3) 表格头内容位置
      let headerAlign = "";
      // (4) 内容位置
      let align
      // (5) 根据不同路由,配置不同表格样式
      if (centerView.includes(routeName)) {
        headerAlign = item.headerAlign || 'center';
        align = item.align || 'center';
      } else {
        if (index === 0) {
          headerAlign = "left";
          align = "left";
        } else if (index === maxIndex) {
          headerAlign = item.headerAlign || "right";
          align = item.align || "right";
        } else if (item.type == 'buttons') {
          headerAlign = "right";
          align = "right";
        } else {
          headerAlign = item.headerAlign || "center";
          align = item.align || "center";
        }        
      };
      // (6) 返回表格配置
      return {
        headerAlign,
        prop: item.prop,
        fixed: item.fixed,
        label: item.title,
        width: item.width || "auto",
        align
      };
    },

    /**************************************************
     * @this 表格数据
     **************************************************/
    getTableText(item, scope) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop]
      if(this.$route.name == "messageDetailed" && item.prop == "content") {
        if (text.length > 8) {
          text = text.substring(0, 8) + '...'
        }
      }


      if ( this.$route.name == 'messagePush' && item.prop == 'courseName' ) {
        let newTextArray = text.split('<br/>')
        newTextArray.map((e, i) => {
          if (e.length > 8) {
            newTextArray[i] = e.substring(0, 8) + '...'
          }
        })

        return newTextArray.join('<br/>')
      }








      if (text === "Invalid date") {
        return "-"
      } else {
        return text || text == "0" ? text : "-"
      }
    },

    handleSelectionChange(tableCol) {
      this.$emit("handleSelectionChange", tableCol)
    },

    
  },
};
</script>

<style lang="less" scoped>
.icon:hover {
  color: #006AFF;
}
.table-imgarr-border {
  display: flex;
  justify-content: left;
  width:auto;
}
.table-imgarr-container {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
    &>p{
      width: 110px;
    }
    .table-imgarr {
      margin-left: 4px;
      width: 86px;
      height: 132px;
      object-fit: cover;
      object-position: top;
    }
}
.showBigImg {
  /deep/ .el-dialog.el-dialog--center {
    border-radius: 8px;
  }
  /deep/ .el-dialog__body {
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: 100%;
    }
  }
}
/deep/ .el-dialog__body {
  overflow: auto;
  width: 880px;
  height: 420px;
  p {
    line-height: 30px;
    color: #45494d;
    padding: 0 40px;
  }
}
.ots-table .el-tag--success {
  background-color: #f1fff7;
  border-color: rgba(29, 191, 96, 0.35);
  color: #1dbf60;
}
.ots-table .el-tag--info {
  background-color: #f4f5f8;
  border-color: #dadde6;
  color: #9299a6;
}
/deep/ .el-table__row .el-button--mini {
  font-size: 13px !important;
  min-width: auto !important;
  padding: 0 !important;
}
/deep/ .el-table__row .el-button--mini:empty{
  display: none;
}
/deep/ .el-button + .el-button {
  margin-left: 16px;
}

.batchOperation {
  margin-bottom: 16px;
  ul {
    display: flex;
    li {
      a {
        border-radius: 20px;
        border: 1px solid #E1E6ED;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #006AFF;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}

/deep/ .el-table th > .cell {
  padding-left: 14px;
  padding-right: 14px;
}
.table-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  object-position: top;
}
.table-img-container:hover .big-img {
  display: block !important;
  width: 116px;
  height: 152px;
}
.table-img-container {
  .big-img {
    left: 100px;
    top:-30px;
    position: absolute;
    z-index: 100000000!important;
    img {
      width: 116px;
      height: 152px;
    }
  }
}
.tagZ i{
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background-color: currentColor;
  border-radius: 50%;
}
.iconfont.f12{
  font-size: 12px;
}
/deep/ .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
